<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 运输信息
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>

                <el-select  filterable v-model='enterpriseSearchId' placeholder='企业' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in enterpiseOptionsSearch'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>
                <el-date-picker
                    v-model='dateValue'
                    type='daterange'
                    range-separator='至'
                    start-placeholder='报警开始日期'
                    end-placeholder='报警结束日期'>
                </el-date-picker>


                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>


            </div>
            <el-dialog title='运输信息列表' :visible.sync='showOrderVis' width='90%'>
                <el-table
                    :data='orderEnterpriseData'
                    border
                    class='table'
                    ref='multipleTable'
                    header-cell-class-name='table-header'
                >
                    <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                    </el-table-column>
                    <el-table-column label='企业名称' align='center'>
                        <template slot-scope='scope'>{{ scope.row.enterpriseName }}</template>
                    </el-table-column>

                    <el-table-column label='污水罐编号' align='center'>
                        <template slot-scope='scope'>{{ scope.row.deviceN }}</template>
                    </el-table-column>
                    <el-table-column label='运送司机' align='center' width='60'>
                        <template slot-scope='scope'>{{ scope.row.deviceName }}</template>
                    </el-table-column>
                    <el-table-column label='车辆牌照' align='center' width='60'>
                        <template slot-scope='scope'>{{ scope.row.licensePlate }}</template>
                    </el-table-column>
                    <!--                <el-table-column label='COD浓度' align='center' width='60'>-->
                    <!--                    <template slot-scope='scope'> {{ scope.row.taskListPo.cod }}</template>-->
                    <!--                </el-table-column>-->
                    <el-table-column label='订单状态' align='center'>
                        <template slot-scope='scope'>{{ scope.row.statusName }}</template>
                    </el-table-column>

                    <el-table-column label='企业照片' align='center'>
                        <template slot-scope='scope'>

                            <el-image
                                style='width: 80px; height: 80px'
                                :src='scope.row.enterprisePhoto'

                                :preview-src-list='[scope.row.enterprisePhoto]'
                                :fit='fit'>
                                <div slot="error" class="image-slot" style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                    <div >暂无图片</div>
                                </div>

                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label='污水罐照片' align='center'>
                        <template slot-scope='scope'>

                            <el-image
                                style='width: 80px; height: 80px'
                                :src='scope.row.sewagePhoto'

                                :preview-src-list='[scope.row.sewagePhoto]'
                                :fit='fit'>
                                <div slot="error" class="image-slot" style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                    <div >暂无图片</div>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>



                    <el-table-column label='报警时间' align='center'>
                        <template slot-scope='scope'>{{ scope.row.alarmTime }}</template>
                    </el-table-column>
                    <el-table-column label='操作' width='120' align='center'>
                        <template slot-scope='scope' v-if='scope.row.status ==0'>
                            <el-button
                                type='text'
                                @click='cancelOrder(scope.$index, scope.row)'
                            >取消指派
                            </el-button>
                        </template>
                    </el-table-column>


                </el-table>

                <span slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='showOrderVis = false'>确 定</el-button>
            </span>
            </el-dialog>

            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column label='企业名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>

                <el-table-column label='污水罐编号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.deviceN }}</template>
                </el-table-column>
                <el-table-column label='运送司机' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.deviceName }}</template>
                </el-table-column>
                <el-table-column label='车辆牌照' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.licensePlate }}</template>
                </el-table-column>
                <el-table-column label='订单状态' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.statusName }}</template>
                </el-table-column>

                <el-table-column label='企业照片' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.taskListPo.enterprisePhoto'

                            :preview-src-list='[scope.row.taskListPo.enterprisePhoto]'
                            :fit='fit'>

                            <div slot="error" class="image-slot" style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div >暂无图片</div>
                            </div>

                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label='污水罐照片' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.taskListPo.sewagePhoto'

                            :preview-src-list='[scope.row.taskListPo.sewagePhoto]'
                            :fit='fit'>
                            <div slot="error" class="image-slot" style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div >暂无图片</div>
                            </div>


                        </el-image>
                    </template>
                </el-table-column>


                <el-table-column label='报警时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.taskListPo.alarmTime }}</template>
                </el-table-column>
                <el-table-column label='操作' width='120' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            @click='handleOrdr(scope.$index, scope.row)'
                        >查看订单列表
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';
import { baseUrl } from '@/utils/nHttp';

export default {
    name: 'basetable',
    data() {
        return {
            dateValue: [],
            enterpriseSearchId:"",
            enterpiseOptionsSearch:[],
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            queryService: {
                name: '',
                pageIndex: 1,
                pageSize: 10000
            },
            memberVisible:false,
            tableData: [],
            multipleSelection: [],
            delList: [],
            cardPwdType: '0',
            editVisible: false,
            addVisible: false
            ,
            createForm: {}
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: [],
            editValue: [],
            provinceOptions: [],
            cityOptions: [],
            provinceValue: '',
            cityValue:"",
            areaOptions:[],
            areaValue:"",
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            serviceProviderOptions: [],
            serviceProviderValue: [],
            lastEnterpriseOptions: [],
            lastEnterpriseValue: '',
            memberStartTimeStr:"",
            memberEndTimeStr:"",
            showOrderVis: false,
            orderEnterpriseId: '',
            orderEnterpriseData: []


        };
    },
    created() {
        this.getData();
        this.getEnterpiseSearch();
        // this.getCity();

    },

    watch: {

        //监听内容
        provinceValue() {
            let that = this;
            this.areaValue=''
            this.cityValue=''
            let param = {"id":this.provinceValue}
            this.http.get('user/getCity', param).then(res => {
                    if (res.code == 0) {
                        that.cityOptions = [{"id":"","name":"请选择市"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });

            console.log("provinceValue"+this.provinceValue)
        },
        cityValue(){
            let that = this;
            let param = {"id":this.cityValue}
            this.areaValue=''
            this.http.get('user/getAreaById', param).then(res => {
                    if (res.code == 0) {
                        that.areaOptions =[{"id":"","name":"请选择区"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        areaValue(){
            let that = this;

        }
    },
    methods: {
        getWebTask() {
            let that = this;

            let param = {};
            if (this.dateValue != null && this.dateValue.length == 2) {
                console.log(formatDate(this.dateValue[0]));
                param.alarmTimeStart = formatDate(this.dateValue[0]).substring(0, 10);
                param.alarmTimeEnd = formatDate(this.dateValue[1]).substring(0, 10);
            } else {
                param.alarmTimeStart = '';
                param.alarmTimeEnd = '';
            }
            param.enterpriseId = this.orderEnterpriseId;
            param.pageIndex = 1;
            param.pageSize = 10000;
            this.http.getToken('/Task/getWebTransDetailsTask', param).then(res => {
                    if (res.code == 0) {
                        that.orderEnterpriseData = res.data.records;
                    }
                },
                err => {

                });
        },
        handleOrdr(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.orderEnterpriseId = this.form.id;
            this.showOrderVis = true;
            this.getWebTask();
        },
        cancelOrder(index, row){
            this.idx = index;
            let that = this
           let msg="是否要取消指派"
            this.form = JSON.parse(JSON.stringify(row));
             let params={}

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('/Task/cancel', this.form).then(res => {
                        if (res.code == 0) {
                            that.getWebTask();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });

        },
        getEnterpiseSearch() {
            let that = this;
            let param = {}
            this.http.getToken('/qwpenterprise/getListOption', param).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptionsSearch.push({ 'value': '', 'label': '请选择企业' });
                        res.data.forEach(res => {
                            that.enterpiseOptionsSearch.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {

                });
        },





        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';

                msg = '确定要审批通过吗？' ;
                params = { 'id': row.id, 'status': 1 };

//0不可用1可用
            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.post('qwpenterprise/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        indexMethod(index) {
            return index + 1;
        },
        getCity() {

        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.query.provinceId = this.provinceValue;
            this.query.cityId = this.cityValue;

            this.getData();

        }
        ,

        getData() {
            let param = {};
            if (this.dateValue != null && this.dateValue.length == 2) {
                console.log(formatDate(this.dateValue[0]));
                this.query.alarmTimeStart = formatDate(this.dateValue[0]).substring(0, 10);
                this.query.alarmTimeEnd = formatDate(this.dateValue[1]).substring(0, 10);
            } else {
                this.query.alarmTimeStart = '';
                this.query.alarmTimeEnd = '';
            }
            let that = this;
            this.query.enterpriseId=this.enterpriseSearchId
            this.http.getToken('/Task/getWebTransTask',   this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                    }
                },
                err => {

                });
        },
        // getData() {
        //     let param = {};
        //     if (this.dateValue != null && this.dateValue.length == 2) {
        //         console.log(formatDate(this.dateValue[0]));
        //         param.alarmTimeStart = formatDate(this.dateValue[0]).substring(0, 10);
        //         param.alarmTimeEnd = formatDate(this.dateValue[1]).substring(0, 10);
        //     } else {
        //         param.alarmTimeStart = '';
        //         param.alarmTimeEnd = '';
        //     }
        //     let that = this;
        //     param.enterpriseId=this.enterpriseSearchId
        //     param.pageIndex = 1;
        //     param.pageSize = 10000;
        //     this.http.getToken('/Task/getWebTask', param).then(res => {
        //             if (res.code == 0) {
        //                 that.tableData = res.data.records;
        //                 that.pageTotal = parseInt(res.data.total);
        //                 this.$message.success('获取数据成功');
        //             }
        //         },
        //         err => {
        //
        //         });
        // },
        delUserHttp(id) {
            let that = this;
            this.http.postToken('/SewageTank/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.addVisible = true;
            this.createForm = {};

        },

        addUserHttp() {
            let that = this;
            this.http.postToken('SewageTank/add', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');
                }

            });
        }

,
        editHttp() {
            console.log(this.form)

            let that = this;

            // this.form.provinceId = this.form.value[0];
            // this.form.cityId = this.form.value[1];
            // this.form.cardPwdType = this.cardPwdType;


            this.http.postToken('SewageTank/editById', this.form).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }
            });
        }
        ,
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.form.enterpriseId= this.form.enterpriseId+""

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
